import React, { useEffect, useState } from 'react'
import { VictoryPie } from 'victory'

import { iconCertNotEarned } from '../../assets'
import { SvgIcon } from '../svg-icon'
import {
  GoldMedallion,
  SilverMedallion,
  BronzeMedallion,
  NotStartedMedallion,
  StartedMedallion,
  InactiveMedallion,
} from './variants'

interface MedallionProps {
  type: string | null
  recall?: number | null
  style?: React.CSSProperties
  scale?: number
  mini?: boolean
  hideRecall?: boolean
}

const initData = [
  { y: 0, fill: 'none' },
  { y: 100, fill: 'none' },
]

export const Medallion = (props: MedallionProps) => {
  const { hideRecall, type, mini, scale = 1, recall, style } = props

  const [finalData, setFinalData] = useState(initData)

  const fillValue = Math.round((recall ?? 0) * 100)
  const size = 100

  const fill = type === 'white' ? '#000' : type === 'grey' ? '#fff' : '#ffffff80'
  const stroke = type === 'white' ? '#ffffff50' : type === 'grey' ? '#ffffff20' : '#ffffff50'

  useEffect(() => {
    const timer = setTimeout(() => {
      setFinalData([
        { y: fillValue, fill },
        { y: 100 - fillValue, fill: 'none' },
      ])
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  const renderBase = () => {
    switch (type) {
      case null:
        return <SvgIcon src={iconCertNotEarned} size={size} />
      case 'Bronze':
        return (
          <div style={{ position: 'relative' }}>
            <div style={{ zIndex: 999 }}>
              <BronzeMedallion height={size} width={size} />
            </div>
            <div
              style={{
                zIndex: -1,
                position: 'absolute',
                height: size / 2,
                width: size / 2,
                backgroundColor: '#fff',
                left: 20,
                top: 20,
              }}
            />
          </div>
        )
      case 'Silver':
        return (
          <div style={{ position: 'relative' }}>
            <div style={{ zIndex: 999 }}>
              <SilverMedallion height={size} width={size} />
            </div>
            <div
              style={{
                zIndex: -1,
                position: 'absolute',
                height: size / 2,
                width: size / 2,
                backgroundColor: '#fff',
                left: 20,
                top: 20,
              }}
            />
          </div>
        )
      case 'Gold':
        return (
          <div style={{ position: 'relative' }}>
            <div style={{ zIndex: 999 }}>
              <GoldMedallion height={size} width={size} />
            </div>
            <div
              style={{
                zIndex: -1,
                position: 'absolute',
                height: size / 2,
                width: size / 2,
                backgroundColor: '#fff',
                left: 20,
                top: 20,
              }}
            />
          </div>
        )
      case 'Not-Started':
        return <NotStartedMedallion height={size} width={size} />
      case 'Started':
        return <StartedMedallion height={size} width={size} />
      default:
        return <InactiveMedallion height={size} width={size} />
    }
  }

  return (
    <div style={{ zIndex: 999, transform: `scale(${scale})`, alignSelf: 'center', ...style }}>
      {!hideRecall && (
        <div style={RECALL}>
          <svg viewBox={`-7 -6 ${size * 1.5} ${size * 1.5}`} height={size} width={size}>
            <circle
              cx={size / 2.0}
              cy={size / 2.0}
              r={size / 2.0}
              stroke={stroke}
              strokeWidth={12}
              fill="none"
            />
            <VictoryPie
              standalone={false}
              radius={size / (mini ? 2.4 : 2.2)}
              origin={{ x: size / 2.0, y: size / 2.0 }}
              innerRadius={size / (mini ? 1.9 : 1.79)}
              cornerRadius={40}
              animate={{ easing: 'sin', duration: 2000 }}
              data={finalData}
              style={{
                labels: { display: 'none' },
                data: {
                  fill: ({ datum }) => datum.fill,
                  opacity: ({ datum }) => datum.opacity,
                },
              }}
            />
          </svg>
        </div>
      )}
      {renderBase()}
    </div>
  )
}

const RECALL: React.CSSProperties = {
  position: 'absolute',
  marginLeft: 12,
  marginTop: 12,
  zIndex: 999,
}
